import { Link } from "react-router-dom";
import { useState } from "react";
import { useMutation } from "@tanstack/react-query";
import toast from "react-hot-toast";
import API from "../api/api";
import PublicFooter from "../components/PublicFooter";
import { isValidEmail } from "../utils/contactValidation";

const initialForm = {
  name: "",
  email: "",
  phone: "",
  subject: "",
  message: ""
};

export default function Contact({ user, onLogout }) {
  const [form, setForm] = useState(initialForm);
  const [errors, setErrors] = useState({});

  const validate = () => {
    const nextErrors = {};

    if (!form.name.trim()) nextErrors.name = "Naam is verplicht";
    if (!form.email.trim() || !isValidEmail(form.email)) nextErrors.email = "Geef een geldig e-mailadres in";
    if (!form.message.trim()) nextErrors.message = "Bericht is verplicht";
    if (form.message.trim() && form.message.trim().length < 10) nextErrors.message = "Bericht moet minstens 10 tekens bevatten";

    setErrors(nextErrors);
    return Object.keys(nextErrors).length === 0;
  };

  const contactMutation = useMutation({
    mutationFn: () => API.post("/contact", form),
    onSuccess: (res) => {
      toast.success(res.data.message || "Bericht succesvol verzonden");
      setForm(initialForm);
      setErrors({});
    },
    onError: (error) => {
      toast.error(error.response?.data?.error || "Bericht verzenden mislukt");
    }
  });

  const submit = (event) => {
    event.preventDefault();
    if (!validate()) return;
    contactMutation.mutate();
  };

  const updateField = (field, value) => {
    setForm({ ...form, [field]: value });
    if (errors[field]) setErrors({ ...errors, [field]: "" });
  };

  return (
    <main className="public-shell">
      <aside className="public-sidebar">
        <div className="sidebar-brand">
          <p className="sidebar-brand-title">DR-Renting</p>
          <p className="sidebar-brand-subtitle">Contact</p>
        </div>
        <Link className="sidebar-button" to="/">Homepagina</Link>
        <Link className="sidebar-button active" to="/contact">Contact</Link>
        {user && <Link className="sidebar-button" to="/dashboard">Dashboard</Link>}
        <div className="public-sidebar-bottom">
          {user ? (
            <button className="sidebar-button danger" onClick={onLogout}>Afmelden</button>
          ) : (
            <Link className="sidebar-button" to="/login">Medewerker login</Link>
          )}
        </div>
      </aside>

      <section className="public-page">
        <div className="panel panel-pad public-intro">
          <h1 className="page-title">Contact</h1>
          <p className="page-subtitle">Heb je een algemene vraag? Stuur ons een bericht en we nemen contact met je op.</p>

          <form className="detail-section" onSubmit={submit}>
            <div className="form-grid">
              <label className="field">
                <span className="field-label">Naam</span>
                <input className="input" value={form.name} onChange={(event) => updateField("name", event.target.value)} />
                {errors.name && <span className="field-error">{errors.name}</span>}
              </label>
              <label className="field">
                <span className="field-label">E-mail</span>
                <input className="input" type="email" value={form.email} onChange={(event) => updateField("email", event.target.value)} />
                {errors.email && <span className="field-error">{errors.email}</span>}
              </label>
              <label className="field">
                <span className="field-label">Telefoonnummer optioneel</span>
                <input className="input" type="tel" value={form.phone} onChange={(event) => updateField("phone", event.target.value)} />
              </label>
              <label className="field">
                <span className="field-label">Onderwerp optioneel</span>
                <input className="input" value={form.subject} onChange={(event) => updateField("subject", event.target.value)} />
              </label>
            </div>

            <label className="field" style={{ marginTop: 12 }}>
              <span className="field-label">Bericht</span>
              <textarea className="textarea" value={form.message} onChange={(event) => updateField("message", event.target.value)} />
              {errors.message && <span className="field-error">{errors.message}</span>}
            </label>

            <button className="button" type="submit" disabled={contactMutation.isPending} style={{ marginTop: 16 }}>
              {contactMutation.isPending ? "Verzenden..." : "Bericht verzenden"}
            </button>
          </form>
        </div>
        <PublicFooter />
      </section>
    </main>
  );
}
